import React from 'react';

import classname from '@search/classname/src';
import { Checkbox } from '@vtblife/uikit';
import { BuildEpoch } from '@search/filter-enums/enums';
import { YearBuildingFilter } from '../../../models/Filter';
import { INumberRange } from '../../../types/IRange';

import './BuildEpochFilterView.css';

const cn = classname.bind(null, 'BuildEpochFilterView');

const buildEpochMapping = [
    {
        value: BuildEpoch.STALIN,
        label: 'Сталинка',
        years: {
            from: 1933,
            to: 1956
        }
    },
    {
        value: BuildEpoch.KHRUSHCHEV,
        label: 'Хрущевка',
        years: {
            from: 1957,
            to: 1969
        }
    },
    {
        value: BuildEpoch.BREZHNEV,
        label: 'Брежневка',
        years: {
            from: 1970,
            to: 1980
        }
    }
];

interface IBuildEpochFilterView {
    filter: YearBuildingFilter;
    onChange: (value: INumberRange) => void;
    isMobile?: boolean;
    withoutEpochTitle?: boolean;
}

export const BuildEpochFilterView = ({
    filter,
    isMobile,
    onChange,
    // withoutEpochTitle
}: IBuildEpochFilterView) => {
    // const title = isMobile ? 'Временная эпоха' : (<Typography variant='secondary-alone' className={cn('title')}>
    //     или временная эпоха
    // </Typography>);

    const onChangeEpoch = React.useCallback(({ check, years }: {
        check: boolean;
        years: {
            from: number;
            to: number;
        };
    }): void => {
        if (! check) {
            onChange({ from: null, to: null });

            return;
        }

        onChange(years);
    }, [ onChange ]);

    return (
        <div className={cn('buildEpoch', { isMobile })}>
            {buildEpochMapping.map(({ value, label, years }) => (
                <div
                    key={value}
                    style={{ width: 'max-content' }}
                >
                    <Checkbox
                        name={label}
                        value={filter.value.from === years.from && filter.value.to === years.to}
                        onChange={check => onChangeEpoch({ check, years })}
                        variant='filter'
                        block
                    >
                        { label }
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
